import * as React from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

/*
 * Thin wrapper over shadcn's Breadcrumb primitives that takes a flat
 * crumbs array and inserts separators automatically. The last item is
 * always rendered as the current page (BreadcrumbPage). Items with `to`
 * become react-router links via `asChild`; items without are plain
 * labels.
 */

export interface PageBreadcrumb {
  label: React.ReactNode;
  /** Omit (or pass null) to render as plain text instead of a link. */
  to?: string | null;
}

interface PageBreadcrumbsProps {
  items: PageBreadcrumb[];
  className?: string;
}

export function PageBreadcrumbs({ items, className }: PageBreadcrumbsProps) {
  if (items.length === 0) return null;

  return (
    <Breadcrumb className={className}>
      <BreadcrumbList>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <Fragment key={index}>
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{item.label}</BreadcrumbPage>
                ) : item.to ? (
                  <BreadcrumbLink asChild>
                    <Link to={item.to}>{item.label}</Link>
                  </BreadcrumbLink>
                ) : (
                  <span className="text-muted-foreground">{item.label}</span>
                )}
              </BreadcrumbItem>
              {isLast ? null : <BreadcrumbSeparator />}
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
